<template>
  <hm-content title="促销列表">
    <div class="table-panel flex flex-between">
      <div class="flex flex-wrap item-center">
        <el-button type="primary" size="small" class="mr10" @click="addStore"
          >新增商户</el-button
        >
        <el-button
          type="primary"
          size="small"
          class="mr10"
          @click="riskManagementSet"
          >申报风控设置</el-button
        >
        <div class="flex flex-end">
          <div
            @click="(openDownLoad) => (downloadVisible = true)"
            class="delete mr20 pointer"
          >
            <span class="delete-icon hmicon icon-daochu"></span>
            下载模板
          </div>
          <div
            @click="(openExport) => (exportVisible = true)"
            class="delete mr20 pointer"
          >
            <span class="delete-icon hmicon icon-daoru"></span>
            导入
          </div>
          <!-- <div class="delete mr20 pointer open-file">
            <span class="delete-icon hmicon icon-daoru"></span>
            导出
            <input
              type="file"
              @change="importf"
              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            />
          </div> -->
          <!-- <div @click="outputExcel" class="delete mr20 pointer">
            <span class="delete-icon hmicon icon-daochu"></span>
            导出模板
          </div>
          <div class="delete mr20 pointer open-file">
            <span class="delete-icon hmicon icon-daoru"></span>
            导入商户及门店
            <input
              type="file"
              @change="importf"
              accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            />
          </div>
          <div class="delete mr20 pointer open-file">
            <span class="delete-icon hmicon icon-daoru"></span>
            导入商户及门店(新)
            <input
                type="file"
                @change="importfNew"
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            />
          </div>
          <div @click="outputExcelShopType" class="delete mr20 pointer">
            <span class="delete-icon hmicon icon-daochu"></span>
            导出设置品牌店模板
          </div>
          <div class="delete mr20 pointer open-file">
            <span class="delete-icon hmicon icon-daoru"></span>
            批量设置品牌店
            <input
                type="file"
                @change="importfShopType"
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            />
          </div> -->
        </div>
      </div>

      <div>
        <el-date-picker
          :default-time="['00:00:00', '23:59:59']"
          class="mr10"
          size="small"
          value-format="yyyy-MM-dd HH:mm:ss"
          v-model="searchCondition.applyDate"
          type="datetimerange"
          range-separator="至"
          start-placeholder="选择创建时间段"
          end-placeholder="选择创建时间段"
        ></el-date-picker>
        <el-input
          clearable
          v-model.trim="searchCondition.storeName"
          placeholder="请输入商户名称"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
    </div>
    <div class="table">
      <div>
        <span>已选{{ num }}条</span>
      </div>
      <el-table
        stripe
        :data="storeBasucList.records"
        @selection-change="getChecked"
        style="width: 100%"
        id="table"
        size="small"
        border
        :default-sort="{ prop: 'num' }"
      >
        <el-table-column type="selection"></el-table-column>
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
          :index="(index) => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="storeName"
          label="商户名称"
        ></el-table-column>
        <el-table-column header-align="center" align="center" label="商户地址">
          <template slot-scope="scope">
            {{ scope.row.provinceName }}{{ scope.row.cityName
            }}{{ scope.row.districtName }}{{ scope.row.store_address }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="storeCode"
          label="商户编码"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="shopCount"
          label="门店数"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.shopCount }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="rewardNum"
          label="当前活动数"
        >
          <template slot-scope="scope">
            <div class="blue pointer" @click="goAct(scope.row)">
              {{ scope.row.rewardNum }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="sendRedMoneyFlag"
          label="是否有发过红包"
        >
          <template slot-scope="scope">
            <div class="success" v-if="scope.row.sendRedMoneyFlag === 'yes'">
              发放过
            </div>
            <div class="gray" v-else>未发放过</div>
          </template>
        </el-table-column>
        <!-- <el-table-column
          header-align="center"
          align="center"
          prop="rewardMoney"
          label="累计红包金额"
        >
        </el-table-column> -->
        <!-- <el-table-column
          header-align="center"
          align="center"
          prop="status"
          label="启用状态"
          width="180"
        >
        <template slot-scope="scope">
          <el-switch
          v-model="scope.row.status"
          size="mini"
          active-color="#13ce66"
          inactive-color="#ff4949"
          active-value="yes"
          active-text="启用"
          inactive-text="禁用"
          inactive-value="no"
          >
          </el-switch>
        </template>
        </el-table-column> -->
        <el-table-column
          header-align="center"
          align="center"
          prop="storeCode"
          label="是否维护小票"
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.ifTemplate === "yes" ? "已维护" : "未维护" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="switch"
          label="申报风控开关"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.switch">{{ scope.row.switch }}</span>
            <span class="gray" v-else>未开启</span>
          </template>
        </el-table-column>
        <!-- <el-table-column
          header-align="center"
          align="center"
          prop="storeCode"
          label="小票规则模板"
          width="200"
        >
          <template slot-scope="scope">
           <el-select
                clearable
                class="mr10"
                size="small"
                style="width: 150px"
                filterable
                v-model="scope.row.sysTemplateId"
                placeholder="小票规则模板"
                @change="relativeTypeChange(scope.row)"
              >
              <el-option :label="v.templateName" :value="v.id" v-for="(v,i) in allSysReceiptOcr" :key="i"></el-option>
           </el-select>
          </template>
        </el-table-column> -->
        <el-table-column
          label="操作"
          width="150"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <el-button size="small" type="text" @click="ocrRule(scope.row)"
              >小票规则</el-button
            >
            <el-button size="small" type="text" @click="viewStore(scope.row)"
              >商户门店</el-button
            >
            <el-button size="small" type="text" @click="edit(scope.row)"
              >编辑</el-button
            >
            <el-button size="small" type="text" @click="goReport(scope.row)"
              >报表</el-button
            >
            <el-button size="small" type="text" @click="goReport1(scope.row)"
              >新报表</el-button
            >
            <el-button
              size="small"
              type="text"
              @click="goGetcashAccount(scope.row)"
              >分成账户管理</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="hm-pagination">
      <el-pagination
        background
        :total="storeBasucList.total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total,sizes,  prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div>
    <el-dialog
      :title="mode === 'add' ? '新增门店' : '编辑门店'"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      @close="resetForm('ruleForm')"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="门店名称" prop="storeName">
          <el-input
            size="small"
            placeholder="请输入门店名称"
            v-model="ruleForm.storeName"
          ></el-input>
        </el-form-item>
        <el-form-item class="is-required" label="省市区" prop="citys">
          <el-cascader
            :options="area"
            size="small"
            ref="citys"
            clearable
            placeholder="请选择省市区"
            v-model="ruleForm.citys"
            :props="props"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="门店地址" prop="storeAddress">
          <el-input
            size="small"
            placeholder="请输入门店地址"
            v-model="ruleForm.storeAddress"
          ></el-input>
        </el-form-item>
        <div class="flex flex-center">
          <el-button type="primary" size="small" @click="submitForm('ruleForm')"
            >提交</el-button
          >
          <el-button size="small" @click="resetForm('ruleForm')"
            >返回</el-button
          >
        </div>
      </el-form>
    </el-dialog>
    <el-dialog
      :visible.sync="errValidGoods"
      width="1000px"
      title="导入失败提示"
    >
      <div>
        <div class="flex flex-between">
          <div>
            您有
            <span class="error">{{ errInputResult.length }}</span
            >条数据导入失败
          </div>
          <div>
            您有
            <span class="success"> {{ succInputResult.length }}</span
            >条数据导入成功！
          </div>
        </div>
        <el-table :data="errInputResult" border class="small-table">
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="storeName"
            label="商户名"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="storeAddress"
            label="商户地址"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="shopName"
            label="门店名"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="shopDistrict"
            label="门店所属区域"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="shopAddress"
            label="门店详细地址"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="failMsg"
            label="导入失败原因"
          >
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="errTypeValidGoods"
      width="1000px"
      title="导入失败提示"
    >
      <div>
        <div class="flex flex-between">
          <div>
            您有
            <span class="error">{{ errInputTypeResult.length }}</span
            >条数据导入失败
          </div>
          <div>
            您有
            <span class="success"> {{ succInputTypeResult.length }}</span
            >条数据导入成功！
          </div>
        </div>
        <el-table :data="errInputTypeResult" border class="small-table">
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="storeName"
            label="商户名"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="storeAddress"
            label="商户地址"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="shopName"
            label="门店名"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="shopDistrict"
            label="门店所属区域"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="shopAddress"
            label="门店详细地址"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="shopTypeText"
            label="品牌店标识"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="failMsg"
            label="导入失败原因"
          >
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="dialogAct"
      width="1000px"
      title="活动详情"
      :close-on-click-modal="false"
    >
      <div>
        <el-table
          stripe
          :data="actList"
          border
          size="small"
          style="width: 100%"
        >
          <el-table-column
            type="index"
            label="序号"
            header-align="center"
            align="center"
            :index="(index) => index + (currentPageAct - 1) * pageSizeAct + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="store_name"
            label="供货商名称"
          >
            <template slot-scope="scope">
              <div class="blue pointer" @click="goShopManage(scope.row)">
                {{ scope.row.store_name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="reward_name"
            label="活动名称"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="reward_name"
            label="活动时间"
          >
            <template slot-scope="scope">
              {{ scope.row.reward_start_date }}至{{ scope.row.reward_end_date }}
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="150"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <el-button size="small" type="text" @click="actDetails(scope.row)"
                >详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="hm-pagination">
          <el-pagination
            background
            :total="totalAct"
            @current-change="pagingAct"
            @size-change="handleSizeChangeAct"
            layout="total,sizes,  prev, pager, next, jumper"
            :current-page="currentPageAct"
          ></el-pagination>
        </div>
      </div>
      <el-dialog
        width="1000px"
        title="活动详情"
        :visible.sync="innerVisible"
        append-to-body
      >
        <div class="flex flex-between mb10">
          <div class="flex-1">
            活动名称：{{ detailsSupplierBasicInfo.ruleInfo.rewardName }}
          </div>
          <div class="flex-1">
            活动下线：到期<span class="blue">{{
              detailsSupplierBasicInfo.ruleInfo.autoOfflineDaysLimt
            }}</span
            >天后自动下线
          </div>
          <div class="flex-1 flex flex-wrap">
            <div>适用时段：</div>

            <div
              class="flex flex-center blue"
              v-if="
                detailsSupplierBasicInfo.ruleInfo.dateConfigMode === 'general'
              "
            >
              {{ detailsSupplierBasicInfo.ruleInfo.rewardStartDate }}至{{
                detailsSupplierBasicInfo.ruleInfo.rewardEndDate
              }}
            </div>
            <div
              class="flex flex-center blue"
              v-if="
                detailsSupplierBasicInfo.ruleInfo.dateConfigMode === 'special'
              "
            >
              <div v-if="detailsSupplierBasicInfo.ruleInfo.dateType === 'date'">
                {{ detailsSupplierBasicInfo.ruleInfo.rewardStartDate }}至{{
                  detailsSupplierBasicInfo.ruleInfo.rewardEndDate
                }}的每{{ detailsSupplierBasicInfo.ruleInfo.dateValue }}天
              </div>
              <div v-if="detailsSupplierBasicInfo.ruleInfo.dateType === 'week'">
                {{ detailsSupplierBasicInfo.ruleInfo.rewardStartDate }}至{{
                  detailsSupplierBasicInfo.ruleInfo.rewardEndDate
                }}的
                <span
                  v-for="(v, i) in detailsSupplierBasicInfo.ruleInfo.dateValue"
                  :key="i"
                >
                  {{ i === 0 ? "" : "," }}每周{{ v }}</span
                >
              </div>
              <div
                v-if="detailsSupplierBasicInfo.ruleInfo.dateType === 'month'"
              >
                {{ detailsSupplierBasicInfo.ruleInfo.rewardStartDate }}至{{
                  detailsSupplierBasicInfo.ruleInfo.rewardEndDate
                }}的
                <span
                  v-for="(v, i) in detailsSupplierBasicInfo.ruleInfo.dateValue"
                  :key="i"
                >
                  {{ i === 0 ? "" : "," }}每月{{ v }}号</span
                >
              </div>
            </div>
          </div>
          <!-- <div class="flex-1">
          基础提成：
          <span
            v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'fixed'"
            class="primary"
          >
            ¥{{ detailsSupplierBasicInfo.ruleInfo.rewardValue }}</span
          >
          <span v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'radio'">
            {{ detailsSupplierBasicInfo.ruleInfo.rewardValue }}%</span
          >
        </div>
        <div class="flex-1">
          活动条件：参与该活动的商品每满
          <span class="blue">{{
            detailsSupplierBasicInfo.ruleInfo.rewardNumberLimit
          }}</span>
          件为一组计算活动
        </div> -->
        </div>
        <div class="flex flex-between mb10">
          <div class="flex-1">
            适配组织：{{ detailsSupplierBasicInfo.ruleInfo.departNames }}
          </div>
          <div class="flex-1 flex-wrap">
            活动备注：{{ detailsSupplierBasicInfo.ruleInfo.rewardRemark }}
          </div>
        </div>

        <div class="title mb10">
          适用商户:
          <span
            class="blue"
            v-for="(v, i) in detailsSupplierBasicInfo.ruleInfo.applyStoreCodes"
            :key="i"
          >
            {{ i === 0 ? "" : "," }}{{ v }}</span
          >
        </div>
        <!-- <div class="table mb10">
        <el-table
          stripe
          ref="roleTable"
          :data="detailsSupplierBasicInfo.ruleInfo.applyStoreCodes"
          style="width: 100%"
          id="table"
          size="small"
          border
        >
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="label"
            label="商户名称"
          >
            <template slot-scope="scope">
              {{ scope.row }}
            </template>
          </el-table-column>
        </el-table>
      </div> -->
        <div
          class="title mb10"
          v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'fixed'"
        >
          活动类型：普通活动
        </div>
        <div
          class="title mb10"
          v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'sub'"
        >
          活动类型：差异活动
        </div>
        <div
          class="title mb10"
          v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'radio'"
        >
          活动类型：冲刺活动
        </div>
        <div class="title mb10">活动规则：</div>
        <div
          class="table mb10"
          v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'fixed'"
        >
          <el-table
            stripe
            ref="roleTable"
            :data="detailsSupplierBasicInfo.ruleInfo.ruleRelModelList"
            style="width: 500px"
            border
            id="table"
            size="small"
          >
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="每组件数"
              prop="rewardNumberLimit"
            >
              <template slot-scope="scope">
                每满{{ scope.row.rewardNumberLimit }}件为一组
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="每组额外奖励"
              prop="rewardValue"
            >
              <template slot-scope="scope">
                {{ scope.row.rewardValue }}元
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div
          class="table mb10"
          v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'sub'"
        >
          <el-table
            :data="detailsSupplierBasicInfo.ruleInfo.ruleRelModelList"
            style="width: 100%"
            ref="table"
            stripe
            size="small"
            :show-header="showHeader"
          >
            <el-table-column
              type="index"
              label="序号"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="start"
              label="每组件数"
              width="700"
              prop="rewardNumberLimit"
            >
              <template slot-scope="scope">
                买
                {{ scope.row.rewardNumberLimit }}
                件, 送
                {{ scope.row.rewardSubNum }}
                件,{{
                  new Number(scope.row.rewardNumberLimit) +
                  new Number(scope.row.rewardSubNum)
                }}件为一组，发放
                {{ scope.row.rewardNumberLimit }}件商品的单件奖励, 每组额外奖励
                {{ scope.row.rewardValue }}
                元
              </template>
            </el-table-column>

            <!-- <el-table-column
                header-align="center"
                align="center"
                label="操作"
                width="100"
              >
                <template slot-scope="scope">
                  <div>
                    <el-button
                      v-if="scope.$index === 0"
                      size="small"
                      @click="addChild(scope.$index)"
                      type="text"
                      >新 增</el-button
                    >
                    <el-button
                      v-else
                      size="small"
                      @click="delRule(scope.$index)"
                      class="danger"
                      type="text"
                      >删 除</el-button
                    >
                  </div>
                </template>
              </el-table-column> -->
          </el-table>
        </div>
        <div
          class="table mb10"
          v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'radio'"
        >
          <el-table
            stripe
            ref="roleTable"
            :data="detailsSupplierBasicInfo.ruleInfo.ruleRelModelList"
            style="width: 500px"
            border
            id="table"
            size="small"
          >
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="冲刺门槛"
              prop="rewardNumberLimit"
            >
              <template slot-scope="scope">
                {{ scope.row.rewardNumberLimit }}件
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="额外奖励"
              prop="rewardValue"
            >
              <template slot-scope="scope">
                每件额外奖励{{ scope.row.rewardValue }}元
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="title mb10">适用商品</div>
        <div class="table mb10">
          <el-table
            stripe
            ref="roleTable"
            :data="detailsSupplierBasicInfo.goodsList"
            style="width: 100%"
            id="table"
            size="small"
            border
          >
            <el-table-column
              type="index"
              label="序号"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="brandName"
              label="商品品牌"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="goodsName"
              label="商品名称"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="goodsBarcode"
              label="商品条码"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="rewardBaseMoney"
              label="单件奖励"
              v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'sub'"
            >
            </el-table-column>
          </el-table>
        </div>
        <div class="flex flex-center">
          <el-button size="small" type="primary" @click="innerVisible = false"
            >确认</el-button
          >
        </div>
      </el-dialog>
    </el-dialog>

    <el-dialog
      title="编辑商户"
      width="800px"
      :visible.sync="dialogFormVisible"
      destroy-on-close
    >
      <el-form
        :model="editRow"
        :rules="rules"
        label-width="100px"
        ref="editForm"
      >
        <el-form-item label="商户名称" prop="storeName">
          <el-input
            v-model="editRow.storeName"
            size="small"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="商户简称" prop="storeAbbr">
          <el-input
            v-model="editRow.storeAbbr"
            size="small"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="品牌色" prop="bgColor">
          <el-color-picker
            @change="changeBgColor"
            :predefine="predefine"
            v-model="editRow.bgColor"
            size="mini"
          ></el-color-picker>
        </el-form-item>
        <el-form-item label="商户Logo" prop="logoPath">
          <my-upload
            field="file"
            @crop-success="cropSuccess"
            @crop-upload-success="cropUploadSuccess"
            @crop-upload-fail="cropUploadFail"
            v-model="show"
            v-if="show"
            noCircle
            noSquare
            :width="100"
            :height="100"
            :headers="{ 'X-Access-Token': $token }"
            :params="{ fileDir: 'mallDecoration' }"
            :url="$uploadUrl"
            img-format="png"
          ></my-upload>
          <el-button
            type="primary"
            size="small"
            v-show="!editRow.logoPath"
            @click="toggleShow"
            >上传</el-button
          >
          <div class="priview" v-if="editRow.logoPath">
            <img :src="editRow.logoPath" alt="主图" />
            <div class="opreat-wrapper flex item-center flex-center">
              <el-button type="text" @click="deleteLogo">删除图片</el-button>
            </div>
          </div>
          <span class="form-tip flex-1">图片尺寸建议300x300</span>
        </el-form-item>
        <el-form-item class="is-required" label="省市区" prop="storeDistrict">
          <el-cascader
            :options="area"
            size="small"
            ref="citys"
            clearable
            placeholder="请选择省市区"
            v-model="addressCodeList"
            :props="props"
            @change="changeAddressCode"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="商户地址">
          <el-input
            v-model.trim="editRow.store_address"
            size="small"
            placeholder="请输入商户地址"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="商户编码">
          {{ editRow.storeCode }}
        </el-form-item>
        <el-form-item label="门店数">
          {{ editRow.shopCount }}
        </el-form-item>
        <el-form-item label="当前活动数">
          {{ editRow.rewardNum }}
        </el-form-item>
        <el-form-item label="累计红包金额">
          {{ editRow.rewardMoney }}
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer flex flex-center item-center">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitEdit">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="申报风控设置"
      :visible.sync="dialogRiskManagement"
      :close-on-click-modal="false"
    >
      <el-form ref="riskManagement" label-width="200px" class="demo-ruleForm">
        <div v-for="(v, i) in riskManagementList" :key="i">
          <el-form-item class="mb10" :label="v.itemText" :prop="v.itemValue">
            <el-switch
              v-model="v.status"
              active-text="开启"
              inactive-text="关闭"
              active-color="#13ce66"
              active-value="1"
              inactive-value="0"
            ></el-switch>
            <div>{{ v.description }}</div>
          </el-form-item>
        </div>
        <div class="flex flex-center">
          <el-button type="primary" size="small" @click="submitRiskManagement()"
            >确定</el-button
          >
          <el-button size="small" @click="dialogRiskManagement = false"
            >取消</el-button
          >
        </div>
      </el-form>
    </el-dialog>
    <!-- 导入导出 -->
    <el-dialog
      :visible.sync="downloadVisible"
      width="40%"
      title="下载模板"
      :close-on-click-modal="false"
    >
      <el-form
        ref="downloadForm"
        :model="downloadForm"
        :rules="downloadRules"
        label-width="100px"
      >
        <el-form-item label="导出类型" prop="downloadType">
          <el-radio-group
            v-model="downloadForm.downloadType"
            :disabled="title === '导出类型'"
          >
            <div
              style="
                display: flex;
                flex-flow: column nowrap;
                justify-content: flex-start;
                align-items: flex-start;
                padding-top: 12px;
              "
            >
              <el-radio style="margin-bottom: 10px" label="1"
                >商户及门店模板</el-radio
              >
              <el-radio style="margin-bottom: 10px" label="2"
                >品牌店模板</el-radio
              >
            </div>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div class="btn-wrapper flex flex-center">
        <el-button
          size="small"
          type="primary"
          @click="dowloadConfirm('downloadForm')"
          >确 定</el-button
        >
        <el-button size="small" @click="downloadVisible = false"
          >取 消</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="exportVisible"
      width="40%"
      title="导入"
      @close="closeExport"
    >
      <el-form
        ref="exportForm"
        :model="exportForm"
        :rules="exportRules"
        label-width="100px"
      >
        <el-form-item label="导入类型" prop="exportType">
          <el-radio-group
            v-model="exportForm.exportType"
            :disabled="title === '导入类型'"
          >
            <div
              style="
                display: flex;
                flex-flow: column nowrap;
                justify-content: flex-start;
                align-items: flex-start;
                padding-top: 12px;
              "
            >
              <el-radio style="margin-bottom: 10px" label="1"
                >商户及门店模板</el-radio
              >
              <el-radio style="margin-bottom: 10px" label="2"
                >商户及门店模板（新）</el-radio
              >
              <el-radio style="margin-bottom: 10px" label="3"
                >批量设置品牌店</el-radio
              >
            </div>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          v-if="!uploadedFile && exportForm.exportType == '1'"
          label="上传文件"
          prop="uploaded"
        >
          <el-upload
            drag
            multiple
            class="upload-demo"
            action="javascript:;"
            :on-change="importf"
            :before-upload="beforeAvatarUpload"
            :show-file-list="false"
            :auto-upload="false"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item
          v-if="!uploadedFile && exportForm.exportType == '2'"
          label="上传文件"
          prop="uploaded"
        >
          <el-upload
            drag
            multiple
            class="upload-demo"
            action="javascript:;"
            :on-change="importfNew"
            :before-upload="beforeAvatarUpload"
            :show-file-list="false"
            :auto-upload="false"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item
          v-if="!uploadedFile && exportForm.exportType == '3'"
          label="上传文件"
          prop="uploaded"
        >
          <el-upload
            drag
            multiple
            class="upload-demo"
            action="javascript:;"
            :on-change="importfShopType"
            :before-upload="beforeAvatarUpload"
            :show-file-list="false"
            :auto-upload="false"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item v-if="uploadedFile">
          <div class="delete mr20 pointer open-file">
            <span class="delete-icon hmicon el-icon-s-order"></span>
            {{ filesName }}
          </div>
        </el-form-item>
      </el-form>
      <div class="btn-wrapper flex flex-center">
        <el-button
          size="small"
          type="primary"
          @click="exportConfirm('downloadForm')"
          >确 定</el-button
        >
        <el-button size="small" @click="closeExport">取 消</el-button>
      </div>
    </el-dialog>
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";
import area from "@/utils/area";
// import XLSX from "xlsx";
import * as XLSX from "xlsx/xlsx";
import { getCookie, setCookie } from "@/utils/utils";
import { hmComponents, tabBarList, predefine } from "@/utils/tempData";
import myUpload from "vue-image-crop-upload";
import moment from "moment";
let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串
export default {
  components: {
    myUpload,
  },
  data() {
    const patternCitys = function (rule, val, callback) {
      if (!this.ruleForm.citys.length) {
        return callback(new Error("请选择省市区"));
      }
      callback();
    }.bind(this);
    const patternAddress = function (rule, val, callback) {
      if (!this.addressCodeList.length) {
        return callback(new Error("请选择省市区"));
      }
      callback();
    }.bind(this);
    return {
      exportVisible: false,
      downloadVisible: false,
      uploadedFile: false,
      title: "",
      downloadForm: {
        downloadType: "1",
      },
      downloadRules: {
        downloadType: {
          required: true,
          message: "请选择模板类型",
          trigger: "blur",
        },
      },
      exportForm: {
        exportType: "1",
        uploadFile: "",
      },
      exportRules: {
        exportType: {
          required: true,
          message: "请选择模板类型",
          trigger: "blur",
        },
        uploadFile: {
          required: true,
          message: "请上传文件",
          trigger: "blur",
        },
      },
      innerVisible: false,
      totalAct: 0,
      currentPageAct: 1,
      pageSizeAct: 10,
      dialogAct: false,
      actList: [],
      errValidGoods: false,
      errInputResult: [],
      succInputResult: [],
      errTypeValidGoods: false,
      errInputTypeResult: [],
      succInputTypeResult: [],
      area,
      currentRow: {},
      mode: "add",
      dialogVisible: false,
      ruleForm: {
        citys: [],
        storeName: "",
        storeAddress: "",
      },
      props: {
        value: "value",
        label: "label",
        children: "children",
        checkStrictly: true,
      },
      rules: {
        citys: {
          validator: patternCitys,
          trigger: "change",
        },
        storeAddress: {
          required: true,
          trriger: "blur",
          message: "请输入门店地址",
        },
        storeName: {
          required: true,
          trriger: "blur",
          message: "请输入门店名称",
        },
        storeDistrict: {
          validator: patternAddress,
          trigger: "change",
          required: true,
        },
      },
      searchCondition: {
        storeName: "",
        applyDate: [],
      },
      currentPage: 1,
      pageSize: 10,
      allSysReceiptOcr: [],
      editRow: {},
      dialogFormVisible: false,
      num: 0,
      riskManagementList: [],
      checkedRow: [],
      checkedRowString: "",
      dialogRiskManagement: false,
      show: false,
      predefine,
      addressCodeList: [],
      shopTypeList: [],
    };
  },
  computed: mapGetters(["storeBasucList", "detailsSupplierBasicInfo"]),
  watch: {},
  created() {
    const startTime = moment().startOf("day").format("YYYY-MM-DD HH:mm:ss");
    const endTime = moment().endOf("day").format("YYYY-MM-DD HH:mm:ss");
    this.searchCondition.applyDate = [startTime, endTime];
    console.log("created:", this.searchCondition.applyDate);
  },
  mounted() {
    this.getParamsCookie();
    this.queryList();
    // this.queryAllsysReceiptOcr();
    this.queryShopBrandType();
  },
  methods: {
    //导入统一
    exportConfirm() {
      let that = this;
      console.log("导入数据", this.exportForm);
      if (
        this.exportForm.exportType != "" &&
        this.exportForm.uploadFile != ""
      ) {
        if (this.exportForm.exportType == 1) {
          that.$store
            .dispatch("importRedpackageStore", that.exportForm.uploadFile)
            .then((res) => {
              const { code, result } = res;
              if (code === "0") {
                if (result.failList.length) {
                  that.errValidGoods = true;
                  that.errInputResult = result.failList;
                  that.exportVisible = false;
                  that.uploadedFile = false;
                  that.filesName = "";
                  that.exportForm = {
                    exportType: "1",
                    uploadFile: "",
                  };
                  that.$nextTick(() => {
                    that.$message({
                      message: "操作成功",
                      type: "success",
                    });
                  });
                } else if (result.successList.length) {
                  that.exportVisible = false;
                  that.uploadedFile = false;
                  that.filesName = "";
                  that.exportForm = {
                    exportType: "1",
                    uploadFile: "",
                  };
                  that.$message({
                    message: "导入成功！",
                    type: "success",
                  });
                }
                that.queryList();
                that.succInputResult = result.successList;
              }
            });
        } else if (this.exportForm.exportType == 2) {
          sessionStorage.setItem(
            "redPackageImportStoreList",
            JSON.stringify(that.exportForm.uploadFile)
          );
          that.exportVisible = false;
          that.uploadedFile = false;
          that.filesName = "";
          that.exportForm = {
            exportType: "1",
            uploadFile: "",
          };
          that.$nextTick(() => {
            that.$message({
              message: "操作成功",
              type: "success",
            });
            that.toUrl("ImportMerchantManage");
          });
        } else if (this.exportForm.exportType == 3) {
          that.$store
            .dispatch("importRedpackageStoreShopType", that.exportForm.uploadFile)
            .then((res) => {
              const { code, result } = res;
              if (code === "0") {
                if (result.failList.length) {
                  that.errTypeValidGoods = true;
                  that.errInputTypeResult = result.failList;
                  that.$message({
                    message: "部分导入失败！",
                    type: "warning",
                  });
                } else if (result.successList.length) {
                  that.exportVisible = false;
                  that.uploadedFile = false;
                  that.filesName = "";
                  that.exportForm = {
                    exportType: "1",
                    uploadFile: "",
                  };
                  that.$nextTick(() => {
                    that.$message({
                      message: "导入成功！",
                      type: "success",
                    });
                  });
                }
                that.queryList();
                that.succInputTypeResult = result.successList;
              }
            });
        }
      } else {
        this.$message({
          message: "请选择导入模板类型和上传文件",
          type: "warning",
        });
      }
    },
    beforeAvatarUpload(file) {
      // 限制上传文件的类型
      const isExcel =
        file.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.type === "application/vnd.ms-excel";
      if (!isExcel) {
        this.$message.error("上传文件只能是 Excel 格式!");
        return false;
      }
      return true;
    },
    closeExport() {
      this.exportVisible = false;
      this.uploadedFile = false;
      this.filesName = "";
      this.exportForm = {
        exportType: "1",
        uploadFile: "",
      };
      this.exportVisible = false;
    },
    dowloadConfirm() {
      console.log("导出模板类型", this.downloadForm);
      if (this.downloadForm.downloadType == 1) {
        this.outputExcel();
      } else if (this.downloadForm.downloadType == 2) {
        this.outputExcelShopType();
      }
    },
    async queryShopBrandType() {
      const { result } = await this.$store.dispatch("queryShopBrandType");
      this.shopTypeList = result;
    },
    changeAddressCode(val) {
      if (val.length) {
        this.editRow.storeProvince = val[0];
        this.editRow.storeCity = val[1];
        this.editRow.storeDistrict = val[2];
      } else {
        this.editRow.storeProvince = "";
        this.editRow.storeCity = "";
        this.editRow.storeDistrict = "";
      }
    },
    goGetcashAccount(row) {
      this.$router.push({
        name: "MerchantShareGuiderManage",
        query: {
          storeCode: row.storeCode,
          storeName: row.storeName,
        },
      });
    },
    submitEdit() {
      this.$refs.editForm.validate(async (valid) => {
        if (valid) {
          if (!this.editRow.bgColor) {
            this.editRow.bgColor = "";
          }
          this.editRow.storeProvince = this.addressCodeList[0] || "";
          this.editRow.storeCity = this.addressCodeList[1] || "";
          this.editRow.storeDistrict = this.addressCodeList[2] || "";
          let params = this.editRow;
          await this.$store.dispatch("editStoreName", params);
          this.$message({
            message: " 操作成功",
            type: "success",
          });
          this.dialogFormVisible = false;
          this.queryList();
        }
      });
    },
    //路由跳转
    toUrl(url) {
      this.$router.push({
        name: url,
      });
    },
    async relativeTypeChange(row) {
      const { code } = await this.$store.dispatch("addOcrRule", row);
      if (code === "0") {
        this.$message({
          message: " 操作成功",
          type: "success",
        });
        this.queryList();
      }
    },
    async queryAllsysReceiptOcr() {
      let params = {
        pageSize: 99999,
        pageNo: 1,
      };
      const { code, result } = await this.$store.dispatch(
        "sysReceiptOcrTemplateList",
        params
      );
      if (code === "0") {
        const { records } = result;
        this.allSysReceiptOcr = records;
      }
    },
    actDetails(row) {
      this.innerVisible = true;
      this.$store.dispatch("detailsSupplierRewardRuleInfoList", {
        rewardRuleId: row.reward_rule_id,
      });
    },
    goAct(row) {
      // localStorage.setItem("storeName", row.storeName);
      // this.$router.push({
      //   name: "ActivityManagement",
      //   query: {
      //     storeCode: row.storeCode
      //   }
      // });
      this.currentPageAct = 1;
      this.pageSizeAct = 10;
      this.row = row;
      this.queryActList();
      this.dialogAct = true;
    },
    async queryActList() {
      let params = {
        pageSize: this.pageSizeAct,
        pageNo: this.currentPageAct,
        storeCode: this.row.storeCode,
      };
      // const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));

      // searchCondition.createTimeStart =
      //   this.searchCondition.date && this.searchCondition.date.length > 0
      //     ? this.searchCondition.date[0]
      //     : "";
      // searchCondition.createTimeEnd =
      //   this.searchCondition.date && this.searchCondition.date.length > 0
      //     ? this.searchCondition.date[0]
      //     : "";

      // Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
        "queryStoreRewardList",
        params
      );
      this.actList = result.records;
      this.totalAct = result.total;
    },
    // 导出excel
    outputExcel() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = [
          "商户名",
          "商户地址",
          "门店名",
          "所属区域",
          "详细地址",
        ];
        const data = [];
        this.downloadVisible = false;
        exportJsonToExcel(tHeader, data, "导入商户及门店模板");
      });
    },
    // 导出品牌店模版excel
    outputExcelShopType() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = [
          "商户名",
          "商户地址",
          "门店名",
          "所属区域",
          "详细地址",
          "类型编码",
          "类型名称",
        ];
        const data = [];
        this.shopTypeList.forEach((v) => {
          data.push(["", "", "", "", "", v.itemValue, v.itemText]);
        });
        this.downloadVisible = false;
        exportJsonToExcel(tHeader, data, "导出品牌店模版");
      });
    },
    //导入excel设置品牌店
    importfShopType(e) {
      // const obj = e.target;
      const that = this;
      that.inputData = [];
      that.filesName = e.name;
      // if (!obj.files) {
      //   return;
      // }
      // let f = obj.files[0];
      if (!e.raw) {
        return;
      }
      let f = e.raw;
      let reader = new FileReader();
      reader.onload = function (e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64",
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary",
          });
        }
        let result = null;
        wb.SheetNames.forEach((sheetName) => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1,
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        let formatResult = [];

        result.forEach((v) => {
          formatResult.push({
            storeName: v[0]
              ? (v[0] + "")
                  .replace(/\s*/g, "")
                  .replace("（", "(")
                  .replace("）", ")")
              : "",
            storeAddress: v[1] ? (v[1] + "").replace(/\s*/g, "") : "",
            shopName: v[2] ? (v[2] + "").replace(/\s*/g, "") : "",
            shopDistrict: v[3] ? (v[3] + "").replace(/\s*/g, "") : "",
            shopAddress: v[4] ? (v[4] + "").replace(/\s*/g, "") : "",
            shopType: v[5] ? (v[5] + "").replace(/\s*/g, "") : "",
            shopTypeText: v[6] ? (v[6] + "").replace(/\s*/g, "") : "",
            supplierName: v[7] ? (v[7] + "").replace(/\s*/g, "") : "",
          });
        });
        that.uploadedFile = true;
        that.exportForm.uploadFile = formatResult;
        // that.$store
        //   .dispatch("importRedpackageStoreShopType", formatResult)
        //   .then(res => {
        //     const { code, result } = res;
        //     if (code === "0") {
        //       if (result.failList.length) {
        //         that.errTypeValidGoods = true;
        //         that.errInputTypeResult = result.failList;
        //         that.$message({
        //           message: "部分导入失败！",
        //           type: "warning"
        //         });
        //       } else if (result.successList.length) {
        //         that.$message({
        //           message: "导入成功！",
        //           type: "success"
        //         });
        //       }
        //       that.queryList();
        //       that.succInputTypeResult = result.successList;

        //     }
        //   });
        // sessionStorage.setItem("redPackageImportStoreList", JSON.stringify(formatResult));
        // that.toUrl("ImportMerchantManage");
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
    //导入excel新
    importfNew(e) {
      // const obj = e.target;
      const that = this;
      that.inputData = [];
      that.filesName = e.name;
      // if (!obj.files) {
      //   return;
      // }
      // let f = obj.files[0];
      if (!e.raw) {
        return;
      }
      let f = e.raw;
      let reader = new FileReader();
      reader.onload = function (e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64",
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary",
          });
        }
        let result = null;
        wb.SheetNames.forEach((sheetName) => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1,
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        let formatResult = [];

        result.forEach((v) => {
          formatResult.push({
            storeName: v[0]
              ? (v[0] + "")
                  .replace(/\s*/g, "")
                  .replace("（", "(")
                  .replace("）", ")")
              : "",
            storeAddress: v[1] ? (v[1] + "").replace(/\s*/g, "") : "",
            shopName: v[2] ? (v[2] + "").replace(/\s*/g, "") : "",
            shopDistrict: v[3] ? (v[3] + "").replace(/\s*/g, "") : "",
            shopAddress: v[4] ? (v[4] + "").replace(/\s*/g, "") : "",
          });
        });
        that.uploadedFile = true;
        that.exportForm.uploadFile = formatResult;
        // sessionStorage.setItem("redPackageImportStoreList", JSON.stringify(formatResult));
        // that.toUrl("ImportMerchantManage");
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      // obj.value = "";
      e.value = "";
    },
    // 导入excel
    importf(e) {
      // const obj = e.target;
      const that = this;
      that.inputData = [];
      that.filesName = e.name;
      // if (!obj.files) {
      //   return;
      // }
      // let f = obj.files[0];
      if (!e.raw) {
        return;
      }
      let f = e.raw;
      let reader = new FileReader();
      reader.onload = function (e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64",
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary",
          });
        }
        let result = null;
        wb.SheetNames.forEach((sheetName) => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1,
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        let formatResult = [];

        result.forEach((v) => {
          formatResult.push({
            storeName: v[0]
              ? (v[0] + "")
                  .replace(/\s*/g, "")
                  .replace("（", "(")
                  .replace("）", ")")
              : "",
            storeAddress: v[1] ? (v[1] + "").replace(/\s*/g, "") : "",
            shopName: v[2] ? (v[2] + "").replace(/\s*/g, "") : "",
            shopDistrict: v[3] ? (v[3] + "").replace(/\s*/g, "") : "",
            shopAddress: v[4] ? (v[4] + "").replace(/\s*/g, "") : "",
          });
        });

        that.uploadedFile = true;
        that.exportForm.uploadFile = formatResult;
        // that.$store
        //   .dispatch("importRedpackageStore", formatResult)
        //   .then(res => {
        //     const { code, result } = res;
        //     if (code === "0") {
        //       if (result.failList.length) {
        //         that.errValidGoods = true;
        //         that.errInputResult = result.failList;
        //         that.$message({
        //           message: "部分导入失败！",
        //           type: "warning"
        //         });
        //       } else if (result.successList.length) {
        //         that.$message({
        //           message: "导入成功！",
        //           type: "success"
        //         });
        //       }
        //       that.queryList();
        //       that.succInputResult = result.successList;
        //     }
        //   });
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      // obj.value = "";
      e.value = "";
    },
    fixdata(data) {
      // 文件流转BinaryString
      let o = "";
      let l = 0;
      let w = 10240;
      for (; l < data.byteLength / w; ++l)
        o += String.fromCharCode.apply(
          null,
          new Uint8Array(data.slice(l * w, l * w + w))
        );
      o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
      return o;
    },
    goReport(row) {
      localStorage.setItem("shName", row.storeName);
      this.$router.push({
        name: "StoreReport",
        query: {
          storeCode: row.storeCode,
        },
      });
    },
    goReport1(row) {
      localStorage.setItem("shName", row.storeName);
      this.$router.push({
        name: "StoreReport2",
        query: {
          storeCode: row.storeCode,
          storeName: row.storeName
        },
      });
    },
    viewStore(row) {
      localStorage.setItem("shName", row.storeName);
      this.$router.push({
        name: "MerchantStoreList",
        query: {
          storeCode: row.storeCode,
        },
      });
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    queryList() {
      let params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        queryRewardFlag: "include",
        queryRewardNumStat: "include",
        queryShopStat: "include",
        queryTemplateStat: "include",
        queryRiskeStat: "include",
      };
      console.log("queryList--this.searchCondition:", this.searchCondition);
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      console.log("queryList--searchCondition:", searchCondition);
      searchCondition.createTimeStart =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[0]
          : "";
      searchCondition.createTimeEnd =
        this.searchCondition.applyDate &&
        this.searchCondition.applyDate.length > 0
          ? this.searchCondition.applyDate[1]
          : "";
      Object.assign(params, searchCondition);

      this.setParamsCookie();

      return this.$store.dispatch("queryStoreBasicList", params);
    },
    setParamsCookie() {
      setCookie({
        key: "redpackageMerchantListParamsNew",
        type: "session",
        data: Object.assign({}, this.searchCondition, {
          pageSize: this.pageSize,
          currentPage: this.currentPage,
        }),
      });
    },
    getParamsCookie() {
      const prams = getCookie({
        key: "redpackageMerchantListParamsNew",
        type: "session",
      });
      if (prams) {
        let search = {};
        for (let key in prams) {
          if (key !== "pageSize" && key !== "currentPage") {
            search[key] = prams[key];
          }
        }
        this.searchCondition = search;
        this.pageSize = prams.pageSize;
        this.currentPage = prams.currentPage;
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    pagingAct(page) {
      this.currentPageAct = page;
      this.queryActList();
    },
    handleSizeChangeAct(size) {
      this.currentPageAct = 1;
      this.pageSizeAct = size;
      this.queryActList();
    },
    edit(row) {
      const editRow = JSON.parse(JSON.stringify(row));
      this.editRow = editRow;
      // console.log('editRoweditRow', this.editRow);
      this.addressCodeList = [];
      if (editRow.storeProvince) {
        this.addressCodeList.push(editRow.storeProvince);
      }
      if (editRow.storeCity) {
        this.addressCodeList.push(editRow.storeCity);
      }
      if (editRow.storeDistrict) {
        this.addressCodeList.push(editRow.storeDistrict);
      }
      this.dialogFormVisible = true;
    },
    addStore() {
      window.open(
        "https://platform.hemiao100.com/merchantManagement/storeBasicList"
      );
      // window.location.href = "https://platform.hemiao100.com";
      // this.dialogVisible = true;
      // this.mode = "add";
    },
    ocrRule(row) {
      this.$router.push({
        name: "OcrRule",
        query: {
          storeCode: row.storeCode,
        },
      });
    },
    async submitForm(formName) {
      const valid = await this.$refs[formName].validate();
      if (valid) {
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.dialogVisible = false;
    },
    getChecked(selection) {
      this.checkedRow = selection.map((v) => v.storeCode);
      this.checkedRowString = this.checkedRow.toString();
      console.log("this.checkedRowString:", this.checkedRowString);
      this.num = selection.length;
    },
    async riskManagementSet() {
      if (this.checkedRow.length) {
        console.log("this.checkedRowString:", this.checkedRowString);
        const { code, result } = await this.$store.dispatch("riskMngList", {
          // storeCodes: this.checkedRowString,
          codes:this.checkedRowString,
           type: "store"
        });
        if (code === "0") {
          this.dialogRiskManagement = true;
          this.riskManagementList = result;
          this.riskManagementList.forEach((v) => {
            v.status = v.status.toString();
          });
        }
      } else {
        this.$message({
          message: "请选择！",
          type: "warning",
        });
      }
    },
    async submitRiskManagement() {
      this.riskManagementList.forEach((v) => {
        // v.storeCodes = this.checkedRowString;
        v.codes = this.checkedRowString;
        v.type = "store"
      });
      let prams = JSON.parse(JSON.stringify(this.riskManagementList));
      console.log("prams:", prams);
      const { code } = await this.$store.dispatch("riskMngSave", prams);
      if (code === "0") {
        this.$message({
          message: " 操作成功",
          type: "success",
        });
        this.queryList();
        this.dialogRiskManagement = false;
      }
    },
    goShopManage(row) {
      this.$router.push({
        name: "ShopManage",
        query: {
          storeCode: row.store_code,
          ActStoreCode: this.row.storeCode,
        },
      });
    },
    changeBgColor() {
      this.$forceUpdate();
    },
    toggleShow() {
      this.show = !this.show;
    },
    cropSuccess() {},
    cropUploadFail() {},
    async cropUploadSuccess(jsonData) {
      if (this.show) {
        this.editRow.logoPath = jsonData.result;
      }
    },
    deleteLogo() {
      this.editRow.logoPath = "";
    },
    // async remove(row) {
    //   const result = await this.$confirm("删除本行数据?", "提示", {
    //     confirmButtonText: "确定",
    //     cancelButtonText: "取消",
    //     type: "warning"
    //   });
    //   if (result === "confirm") {
    //     const { code } = await this.$store.dispatch("removeTempMsg", {
    //       templateId: row.template_id
    //     });
    //     if (code === "0") {
    //       this.$message({
    //         message: " 操作成功",
    //         type: "success"
    //       });
    //       this.queryTempMsg();
    //     }
    //   }
    // }
  },
};
</script>
<style lang="scss" scoped>
.error {
  color: #f56c6c;
  font-size: 12px;
  line-height: 1;
  padding-top: 4px;
}
.gray {
  color: #999999;
}
.priview {
  position: relative;
  width: 200px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
    display: block;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
</style>
